import type { ContainerList, ContainerData } from '@atlassiansox/cross-flow-plugins';
import { createGetContainersPlugin, ContainerTypes } from '@atlassiansox/cross-flow-plugins';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';
import { SiteInformationQuery } from '@confluence/session-data/entry-points/SiteInformationQuery.graphql';
import type { SPAViewContextQueryType } from '@confluence/spa-view-context/entry-points/SPAViewContextQueryType';
import type { SiteInformationQueryType } from '@confluence/session-data/entry-points/SiteInformationQuery';

interface SiteSettings {
	siteSettings: {
		siteTitle: string;
	};
	tenant: {
		cloudId: string;
	};
}

function hasSiteSettings(data: unknown): data is SiteSettings {
	return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}

const getCloudId = async (): Promise<ContainerList> => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	const { data } = await getApolloClient().query<
		SiteInformationQueryType | SPAViewContextQueryType
	>({
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		query: SiteInformationQuery,
	});
	const containers: ContainerData[] = [];
	if (hasSiteSettings(data)) {
		const { siteTitle } = data.siteSettings;
		const tenantId = data.tenant.cloudId;

		containers.push({
			id: tenantId,
			displayName: siteTitle,
			type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		});
	}

	return {
		type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		containers,
	};
};

export const getContainersPlugin = createGetContainersPlugin(getCloudId);
